// Timing constants used across carousels / sliders.
// Centralised so it's easy to tune the cadence in one place.

export const HERO_AUTO_ADVANCE_MS = 5500;
export const CASE_STUDY_AUTO_ADVANCE_MS = 5500;
export const TESTIMONIAL_ROTATION_INTERVAL_MS = 6000;
export const CASE_STUDY_TRANSITION_OUT_MS = 280;
